import {Route, useLocation} from "react-router-dom";
import {Main1} from "../Pages/Main1";
import {Manual} from "../Pages/Manual";
import {Credits} from "../Pages/Credits";
import { Routes as BrowserRoutes } from "react-router-dom"
import {useEffect, useState} from "react";
import {logPageView} from "./api";

export const Routes = () => {
  let location = useLocation(); // Create an instance of the history object
  const [userId, setUserId] = useState(Math.random().toString(36).slice(2, 7))

  useEffect(() => {
    trackPageView(); // Track first pageview on initial site load
  }, [location]);

  function trackPageView() {
    const tracking = {userId, key: location.key, location: `${window.location.pathname}`, page: window.location.toString()}
    logPageView(tracking).then(r => console.log(r.data))
  }
  return(
    <>
      <BrowserRoutes>
        <Route path="/*" element={<Main1 />} />
        <Route path="/manual" element={<Manual />} />
        <Route path="/credits" element={<Credits />} />
      </BrowserRoutes>
    </>
  )
}